import './Footer.css';
import facebook from '../../assets/facebook_icon.png';
import insta from '../../assets/instagram_icon.png';
import twitter from '../../assets/twitter_icon.png';
import youtube from '../../assets/youtube_icon.png';
const Footer=()=>{
    return (
        <footer>
        <div className='container'>
            <div className="footer_icon">
                <img src={facebook} alt="facebook icon"/>
                <img src={insta} alt="facebook icon"/>
                <img src={twitter} alt="facebook icon"/>
                <img src={youtube} alt="facebook icon"/>
            </div>
            <ul className='row row-cols-4 footer_list'>
                <li>Audio Discription</li>
                <li>Help Center</li>
                <li>Gift Cards</li>
                <li>Media Center</li>
                <li>Investor Relations</li>
                <li>Jobs</li>
                <li>Terms of Use</li>
                <li>Privacy</li>
                <li>Legal Notice</li>
                <li>Cookies Preference</li>
                <li>Corporate Information</li>
                <li>Contact Us</li>
                <p>Corporate Information</p>
            </ul>
        </div>

        </footer>
    )
}
export default Footer;